import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { formatNumber } from '../../../main-page/home-utils';
import { Check } from '../../../user-panel/components/panel-ui';

export const OfferPackage = ({ item, selected, onSelect }) => {
    const { t } = useTranslation(["offers"]);
    const [detailsOpen, setDetailsOpen] = useState(false);

    const includes = (item.packageIncludes || []).filter(i => i.title);

    return (
        <div className={`hs-panel-card hs-panel-package ${selected ? 'on' : ''}`} onClick={onSelect}>
            <span className='hs-panel-package-name'>{item.name}</span>
            <span className='hs-panel-package-price'>{formatNumber(item.price)} <small>RSD / {t("monthly").toLowerCase()}</small></span>

            <div className='hs-panel-package-stats'>
                <span><strong>{item.num_listings}</strong>{t("num_listings")}</span>
                <span><strong>{item.num_photos}</strong>{t("num_photos")}</span>
                <span><strong>{item.num_agents}</strong>{t("num_agents")}</span>
            </div>

            {includes.length > 0 &&
                <ul className='hs-panel-package-list'>
                    {includes.map((i, index) => (
                        <li key={`package-item-${index}`}><Check size={15} /><span>{i.title} {i.value && <strong>{i.value}</strong>}</span></li>
                    ))}
                </ul>}

            <p className='hs-panel-package-gift'>
                <strong>{t("gift_1")} {item.numOfGift} {t("gift_2")}</strong>
                <span>{t("next")}</span>
            </p>

            {item.details && <>
                <button className='hs-panel-text-btn' onClick={(e) => { e.stopPropagation(); setDetailsOpen(!detailsOpen); }}>
                    {t(detailsOpen ? "hide_information" : "information")}
                </button>
                {detailsOpen && <p className='hs-panel-package-details'>{item.details}</p>}
            </>}

            <button className='hs-panel-primary'>{t("order")}</button>
        </div>
    );
};
